module.exports = __webpack_public_path__ + "img/download_logo.e4624cc6.png";